export default __webpack_public_path__ + "static/media/loading_light_green.24caaf37.svg";